<div class="transaction" *ngIf="transaction" data-qa-block="transaction">
  <svg-icon
    *ngIf="transaction.transactionType === 'Z_REPORT'"
    key="z"
    class="transaction__icon z-report-icon"
  ></svg-icon>

  <svg-icon
    key="a"
    *ngIf="$any(transaction).offlineFiscalId"
    class="transaction__icon offline-transaction-icon"
  ></svg-icon>

  <svg-icon
    key="x"
    *ngIf="transaction.transactionType === 'X_REPORT'"
    class="transaction__icon x-report-icon"
  ></svg-icon>

  <span class="transaction__item">
    <span data-qa="transaction-date-1">{{
      this.transaction?.transactionDate | dateAsync: 'D MMM HH:mm'
    }}</span>
    <div data-qa="transaction-date-2" class="grey-text year">
      {{ this.transaction?.transactionDate | date: 'yyyy' }} {{ 'common.date.year' | translate }}
    </div>
  </span>

  <div class="transaction__item transaction__description">
    <span
      *ngFor="let item of transactionDescriptionArray"
      [class.grey-text]="['OPEN_SHIFT', 'CLOSE_SHIFT'].includes(transaction.transactionType)"
      data-qa="transaction-name"
    >
      <ng-container [ngSwitch]="item">
        <ng-template ngSwitchCase="transaction.report.z">
          {{ 'transaction.close.shift' | translate }} {{ transaction.shiftNumber }}
        </ng-template>
        <ng-template ngSwitchCase="transaction.report.x">
          {{ 'transaction.report.x.title' | translate }} {{ transaction.shiftNumber }}
        </ng-template>
        <ng-template ngSwitchDefault>{{ item | translate }}</ng-template>
      </ng-container>
    </span>
    <tax-transaction-report-totals
      *ngIf="transaction.transactionType === 'Z_REPORT'"
      [transactionTotalResult]="transactionTotalResult"
    ></tax-transaction-report-totals>
  </div>

  <span
    class="transaction__item grey-text"
    data-qa="fiscal-id"
    *ngIf="$any(transaction).offlineFiscalId"
    >{{ $any(transaction).offlineFiscalId }} {{ 'transaction.ticket.offline' | translate }}</span
  >
  <span
    class="transaction__item grey-text"
    data-qa="fiscal-id"
    *ngIf="!$any(transaction).offlineFiscalId"
    >{{ transaction.fiscalId }}</span
  >

  <tax-transaction-report-sum
    *ngIf="transaction.transactionType === 'Z_REPORT'; else simpleSum"
    [transactionTotalResult]="transactionTotalResult"
    class="transaction__sum"
  ></tax-transaction-report-sum>
  <ng-template #simpleSum>
    <span class="transaction__sum" *ngIf="$any(transaction).sum" data-qa="transaction-sum">
      {{ $any(transaction).sum | kzCurrencyDecimal }}
    </span>
  </ng-template>
</div>
